module.exports = __webpack_public_path__ + "img/chart-brutkarmarji.0cc72842.png";